// extracted by mini-css-extract-plugin
export default {"outcomesPage":"OutcomesV1_outcomesPage__LgrbW","dashboard":"OutcomesV1_dashboard__OCDsc","outcomesColumn":"OutcomesV1_outcomesColumn__DrkrY"};